import {
  API_BASE_URL,
  LOGIN_ENDPOINT,
  REGISTER_ENDPOINT,
  PROFILE_ENDPOINT,
  CHANGE_PASSWORD_ENDPOINT,
  DOCTORS_ENDPOINT,
  PATIENTS_ENDPOINT,
  BOOKINGS_ENDPOINT,
  BILLS_ENDPOINT,
  LABREPORTS_ENDPOINT,
  UPLOAD_LABREPORT_ENDPOINT,
  PATIENT_LABREPORTS_ENDPOINT,
  ADMIN_BASE_ENDPOINT,
  ADMIN_STATS_ENDPOINT,
  ADMIN_DOCTORS_ENDPOINT,
  ADMIN_USERS_ENDPOINT,
  ADMIN_BOOKINGS_ENDPOINT,
  ADMIN_BILLS_ENDPOINT,
  ADMIN_RECENT_BILLS_ENDPOINT,
  ADMIN_BILL_PDF_ENDPOINT,
  PAYMENTS_ENDPOINT,
  CREATE_PAYMENT_ORDER_ENDPOINT,
  VERIFY_PAYMENT_ENDPOINT,
  PAYMENT_STATUS_ENDPOINT,
  API_ORIGIN
} from './api_path';

export {
  API_BASE_URL,
  LOGIN_ENDPOINT,
  REGISTER_ENDPOINT,
  DOCTORS_ENDPOINT,
  PATIENTS_ENDPOINT,
  BOOKINGS_ENDPOINT,
  BILLS_ENDPOINT,
  LABREPORTS_ENDPOINT,
  ADMIN_BASE_ENDPOINT,
  PAYMENTS_ENDPOINT,
  API_ORIGIN
};

export const getAllDoctors = async () => {
  try {
    const res = await fetch(DOCTORS_ENDPOINT);
    const data = await res.json();
    // Ensure we return an array
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('Error fetching doctors:', error);
    return [];
  }
};

export const getDoctorById = async (id) => {
  const res = await fetch(`${DOCTORS_ENDPOINT}/${id}`);
  return res.json();
};

export const createDoctor = async (doctor) => {
  const res = await fetch(DOCTORS_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(doctor),
  });
  return res.json();
};

export const updateDoctor = async (id, doctor) => {
  const res = await fetch(`${DOCTORS_ENDPOINT}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(doctor),
  });
  return res.json();
};

export const deleteDoctor = async (id) => {
  const res = await fetch(`${DOCTORS_ENDPOINT}/${id}`, {
    method: 'DELETE',
  });
  return res.json();
};

// Patient API endpoints

export const getAllPatients = async () => {
  const res = await fetch(PATIENTS_ENDPOINT);
  return res.json();
};

export const getPatientById = async (id) => {
  const res = await fetch(`${PATIENTS_ENDPOINT}/${id}`);
  return res.json();
};

export const createPatient = async (patient) => {
  const res = await fetch(PATIENTS_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(patient),
  });
  return res.json();
};

export const updatePatient = async (id, patient) => {
  const res = await fetch(`${PATIENTS_ENDPOINT}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(patient),
  });
  return res.json();
};

export const deletePatient = async (id) => {
  const res = await fetch(`${PATIENTS_ENDPOINT}/${id}`, {
    method: 'DELETE',
  });
  return res.json();
};

// Booking API endpoints

export const getAllBookings = async (email) => {
  try {
    let url = BOOKINGS_ENDPOINT;
    if (email) {
      url += `?email=${encodeURIComponent(email)}`;
    }
    const res = await fetch(url);
    const data = await res.json();
    // Ensure we return an array
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('Error fetching bookings:', error);
    return [];
  }
};

export const getBookingById = async (id) => {
  const res = await fetch(`${BOOKINGS_ENDPOINT}/${id}`);
  return res.json();
};

export const createBooking = async (booking) => {
  const res = await fetch(BOOKINGS_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(booking),
  });
  return res.json();
};

export const updateBooking = async (id, booking) => {
  const res = await fetch(`${BOOKINGS_ENDPOINT}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(booking),
  });
  return res.json();
};

export const deleteBooking = async (id) => {
  const res = await fetch(`${BOOKINGS_ENDPOINT}/${id}`, {
    method: 'DELETE',
  });
  return res.json();
};

// Bill API endpoints

export const getAllBills = async (email) => {
  try {
    let url = BILLS_ENDPOINT;
    if (email) {
      url += `?email=${encodeURIComponent(email)}`;
    }
    const res = await fetch(url);
    const data = await res.json();
    // Ensure we return an array
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('Error fetching bills:', error);
    return [];
  }
};

export const getBillById = async (id) => {
  const res = await fetch(`${BILLS_ENDPOINT}/${id}`);
  return res.json();
};

export const createBill = async (bill) => {
  const res = await fetch(BILLS_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(bill),
  });
  return res.json();
};

export const updateBill = async (id, bill) => {
  const res = await fetch(`${BILLS_ENDPOINT}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(bill),
  });
  return res.json();
};

export const deleteBill = async (id) => {
  const res = await fetch(`${BILLS_ENDPOINT}/${id}`, {
    method: 'DELETE',
  });
  return res.json();
};

// Lab Report API endpoints

export const uploadLabReport = async (formData) => {
  const res = await fetch(UPLOAD_LABREPORT_ENDPOINT, {
    method: 'POST',
    body: formData, // formData should include file, patientId, description
  });
  return res.json();
};

export const getAllLabReports = async (email) => {
  try {
    let url = LABREPORTS_ENDPOINT;
    if (email) {
      url += `?email=${encodeURIComponent(email)}`;
    }
    const res = await fetch(url);
    const data = await res.json();
    // Handle both nested and flat response formats, ensure we return an array
    const reports = data.data || data;
    return Array.isArray(reports) ? reports : [];
  } catch (error) {
    console.error('Error fetching lab reports:', error);
    return [];
  }
};

export const getLabReportsByPatient = async (patientId) => {
  const res = await fetch(PATIENT_LABREPORTS_ENDPOINT(patientId));
  const data = await res.json();
  return data.data || data; // Handle both nested and flat response formats
};

// --- Admin Dashboard Endpoints ---

export const getAdminStats = async () => {
  const res = await fetch(ADMIN_STATS_ENDPOINT);
  return res.json();
};

export const getAdminDoctors = async () => {
  const res = await fetch(ADMIN_DOCTORS_ENDPOINT);
  return res.json();
};

export const getAdminUsers = async () => {
  const res = await fetch(ADMIN_USERS_ENDPOINT);
  return res.json();
};

export const getAdminBookings = async (params = {}) => {
  const url = new URL(ADMIN_BOOKINGS_ENDPOINT);
  Object.entries(params).forEach(([key, value]) => url.searchParams.append(key, value));
  const res = await fetch(url);
  return res.json();
};

export const getAdminBills = async (params = {}) => {
  const url = new URL(ADMIN_BILLS_ENDPOINT);
  Object.entries(params).forEach(([key, value]) => url.searchParams.append(key, value));
  const res = await fetch(url);
  return res.json();
};

export const getAdminRecentBills = async () => {
  const res = await fetch(ADMIN_RECENT_BILLS_ENDPOINT);
  return res.json();
};

export const generateBillPDF = async (billId, { summary } = {}) => {
  try {
    const qs = summary ? `?summary=${encodeURIComponent(summary)}` : '';
    const response = await fetch(`${ADMIN_BILL_PDF_ENDPOINT(billId)}${qs}`, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error('Failed to generate PDF');
    }

    // Get the blob from the response
    const blob = await response.blob();

    // Create a download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `bill-${billId}.pdf`;

    // Trigger download
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error) {
    console.error('Error generating PDF:', error);
    throw error;
  }
};

// Auth API endpoints
export const loginUser = async (credentials) => {
  const res = await fetch(LOGIN_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(credentials),
  });
  return res.json();
};

export const getUserProfile = async (email, role) => {
  try {
    const url = new URL(PROFILE_ENDPOINT);
    url.searchParams.append('email', email);
    url.searchParams.append('role', role);
    const res = await fetch(url);
    const data = await res.json();
    return data;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    return null;
  }
};

export const updateUserProfile = async (profileData) => {
  try {
    console.log('Sending profile update data:', profileData);
    const res = await fetch(PROFILE_ENDPOINT, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(profileData),
    });

    if (!res.ok) {
      const errorData = await res.json();
      console.error('Profile update failed:', errorData);
      throw new Error(errorData.message || `HTTP ${res.status}: ${res.statusText}`);
    }

    const data = await res.json();
    console.log('Profile update response:', data);
    return data;
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
};

export const changePassword = async (passwordData) => {
  try {
    console.log('Sending password change data:', { ...passwordData, currentPassword: '[HIDDEN]', newPassword: '[HIDDEN]' });
    const res = await fetch(CHANGE_PASSWORD_ENDPOINT, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(passwordData),
    });

    if (!res.ok) {
      const errorData = await res.json();
      console.error('Password change failed:', errorData);
      throw new Error(errorData.message || `HTTP ${res.status}: ${res.statusText}`);
    }

    const data = await res.json();
    console.log('Password change response:', data);
    return data;
  } catch (error) {
    console.error('Error changing password:', error);
    throw error;
  }
};

// Payment API endpoints

export const createPaymentOrder = async (orderData) => {
  try {
    const res = await fetch(CREATE_PAYMENT_ORDER_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(orderData),
    });

    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.error || `HTTP ${res.status}: ${res.statusText}`);
    }

    return await res.json();
  } catch (error) {
    console.error('Error creating payment order:', error);
    throw error;
  }
};

export const verifyPayment = async (paymentData) => {
  try {
    const res = await fetch(VERIFY_PAYMENT_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(paymentData),
    });

    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.error || `HTTP ${res.status}: ${res.statusText}`);
    }

    return await res.json();
  } catch (error) {
    console.error('Error verifying payment:', error);
    throw error;
  }
};

export const getPaymentStatus = async (bookingId) => {
  try {
    const res = await fetch(PAYMENT_STATUS_ENDPOINT(bookingId));

    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.error || `HTTP ${res.status}: ${res.statusText}`);
    }

    return await res.json();
  } catch (error) {
    console.error('Error getting payment status:', error);
    throw error;
  }
}; 
